export default [
  {
    path: '/indicator',
    name: 'indicator',
    redirect: '/indicator/heartRate',
    meta: {
      title: '指标',
    },
    children: [
      {
        path: 'heartRate',
        name: 'heartRate',
        component: () => import('@/views/indicator/HeartRate.vue'),
        meta: {
          title: '心率',
        },
      },
      {
        path: 'bloodPressure',
        name: 'bloodPressure',
        component: () => import('@/views/indicator/BloodPressure.vue'),
        meta: {
          title: '血压',
        },
      },
      {
        path: 'bloodOxygen',
        name: 'bloodOxygen',
        component: () => import('@/views/indicator/BloodOxygen.vue'),
        meta: {
          title: '血氧',
        },
      },
      {
        path: 'sleep',
        name: 'sleep',
        component: () => import('@/views/indicator/Sleep.vue'),
        meta: {
          title: '睡眠',
        },
      },
    ],
  },
]
